<template>
  <v-card flat :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
    <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
      <v-sheet class="transactionTable depositTabTable " :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
        <DocumentPendingDataTable></DocumentPendingDataTable>
      </v-sheet>
    </v-card>
    <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
      <v-sheet class="transactionTable depositTabTable " :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
        <DocumentApprovedDataTable></DocumentApprovedDataTable>
      </v-sheet>
    </v-card>
  </v-card>
</template>

<script>
import DocumentApprovedDataTable from './DocumentApprovedDataTable.vue';
import DocumentPendingDataTable from './DocumentPendingDataTable.vue';

export default {
  components: { DocumentPendingDataTable, DocumentApprovedDataTable },
}
</script>